<div *ngIf="cacheEnabled" class="ft-offline-status-wrap">
  <div class="ft-offline-status">
      <button type="button" id="btn-offline-status" class="offlineStatusItems" mat-icon-button [matMenuTriggerFor]="cacheEnabled ? offlineStatusMenu : null" aria-label="Offline Status" (menuOpened)="menuOpened()" (menuClosed)="menuClosed()">
          <mat-icon [class.blink]="cloudIcon === 'cloud_sync'" 
                    [class.green-icon]="cloudIcon === 'cloud_done'"
                    [class.red-icon]="cloudIcon === 'cloud_off'"
                    [class.orange-icon]="cloudIcon === 'cloud_operate_offline'">
              {{ cloudIcon }}
          </mat-icon>
      </button>

      <mat-menu #offlineStatusMenu="matMenu" class="offline-status-menu-wrap" backdropClass="offline-status-menu-wrap">
          
          <div mat-menu-item class="f-flex go-offline-item">
              <div class="f-flex f-flex-align-items-center justify-center" 
                   [style.background-color]="isOffline ? 'orange' : '#555'"
                   style="width: 100%; color: white; padding: 10px; border-radius: 4px; cursor: pointer;"
                   (click)="toggleOffline($event)">
                  <mat-icon style="color: white; margin-right: 8px;">{{ isOffline ? 'wifi' : 'wifi_off' }}</mat-icon>
                  <span>{{ isOffline ? 'Go Online' : 'Go Offline' }}</span>
              </div>
          </div>


          <mat-divider></mat-divider>



          <div mat-menu-item class="f-flex">
              <div class="f-flex f-flex-align-items-center" style="width: 100%; justify-content: space-between;">
                  <div class="f-flex f-flex-align-items-center">
                      <mat-icon style="margin-right: 16px;">sync</mat-icon>
                      <span>Pending sync count</span>
                  </div>
                  <span class="count-value">{{ offlineStatus?.pendingDocumentCount || 0 }}</span>
              </div>
          </div>

          <mat-divider></mat-divider>

          <div mat-menu-item class="f-flex">
              <div class="f-flex f-flex-align-items-center" style="width: 100%; justify-content: space-between;">
                  <div class="f-flex f-flex-align-items-center">
                      <mat-icon style="margin-right: 16px;">upload</mat-icon>
                      <span>Pending upload count</span>
                  </div>
                  <span class="count-value">{{ offlineStatus?.pendingUploadCount || 0 }}</span>
              </div>
          </div>

          <mat-divider></mat-divider>

          <div mat-menu-item class="f-flex">
              <div class="f-flex f-flex-align-items-center" style="width: 100%; justify-content: space-between;">
                  <div class="f-flex f-flex-align-items-center">
                      <mat-icon style="margin-right: 16px;">apps</mat-icon>
                      <span>Static Resources</span>
                  </div>
                  <mat-chip [ngClass]="getStatusClass(appValue, offlineStatus?.appMaxCount)" class="status-chip">{{ getDisplayCount(appValue, offlineStatus?.appMaxCount) }}</mat-chip>
              </div>
          </div>

          <mat-divider></mat-divider>

          <div mat-menu-item class="f-flex">
              <div class="f-flex f-flex-align-items-center" style="width: 100%; justify-content: space-between;">
                  <div class="f-flex f-flex-align-items-center">
                      <mat-icon style="margin-right: 16px;">storage</mat-icon>
                      <span>Data Cache</span>
                  </div>
                  <mat-chip [ngClass]="getStatusClass(dataValue, offlineStatus?.dataMaxCount)" class="status-chip">{{ getDisplayCount(dataValue, offlineStatus?.dataMaxCount) }}</mat-chip>
              </div>
          </div>

          <mat-divider></mat-divider>

          <div mat-menu-item class="f-flex">
              <div class="f-flex f-flex-align-items-center" style="width: 100%; justify-content: space-between;">
                  <div class="f-flex f-flex-align-items-center">
                      <mat-icon style="margin-right: 16px;">map</mat-icon>
                      <span>Map Tiles</span>
                  </div>
                  <mat-chip [ngClass]="getStatusClass(mapValue, offlineStatus?.mapMaxCount)" class="status-chip">{{ getDisplayCount(mapValue, offlineStatus?.mapMaxCount) }}</mat-chip>
              </div>
          </div>

          <mat-divider></mat-divider>

          <div mat-menu-item class="f-flex">
              <div class="f-flex f-flex-align-items-center" style="width: 100%; justify-content: space-between;">
                  <div class="f-flex f-flex-align-items-center">
                      <mat-icon style="margin-right: 16px;">attach_file</mat-icon>
                      <span>Attached Files</span>
                  </div>
                  <mat-chip [ngClass]="getStatusClass(fileValue, offlineStatus?.fileMaxCount)" class="status-chip">{{ getDisplayCount(fileValue, offlineStatus?.fileMaxCount) }}</mat-chip>
              </div>
          </div>

          <mat-divider *ngIf="offlineStatus?.errorCacheAttachedFile.length > 0"></mat-divider>

          <div mat-menu-item class="f-flex" *ngIf="offlineStatus?.errorCacheAttachedFile.length > 0" [matMenuTriggerFor]="cacheErrors">
              <div class="f-flex f-flex-align-items-center" style="width: 100%; justify-content: space-between;">
                  <div class="f-flex f-flex-align-items-center">
                      <mat-icon style="margin-right: 16px; color: red;">error</mat-icon>
                      <span style="color: red;">Attached File Errors</span>
                  </div>
                  <span class="count-value" style="color: red;">{{ offlineStatus?.errorCacheAttachedFile.length }}</span>
              </div>
          </div>

          <mat-divider *ngIf="offlineStatus?.errorOfflineChangesSyncDocs.length > 0"></mat-divider>

          <div mat-menu-item class="f-flex" *ngIf="offlineStatus?.errorOfflineChangesSyncDocs.length > 0" [matMenuTriggerFor]="syncErrors">
              <div class="f-flex f-flex-align-items-center" style="width: 100%; justify-content: space-between;">
                  <div class="f-flex f-flex-align-items-center">
                      <mat-icon style="margin-right: 16px; color: red;">sync_problem</mat-icon>
                      <span style="color: red;">Sync Errors</span>
                  </div>
                  <span class="count-value" style="color: red;">{{ offlineStatus?.errorOfflineChangesSyncDocs.length }}</span>
              </div>
          </div>

      </mat-menu>

      <mat-menu #cacheErrors="matMenu" class="offline-status-sub-menu-wrap">
          <div mat-menu-item (click)="$event.stopPropagation(); clearErrorCachingAttachedFiles()">
              <mat-icon>delete_sweep</mat-icon>
              <span>Clear Errors</span>
          </div>
          <mat-divider></mat-divider>
          <div *ngFor="let err of offlineStatus?.errorCacheAttachedFile; let i = index" mat-menu-item style="height: auto; line-height: normal; padding-top: 8px; padding-bottom: 8px;">
              <span style="white-space: normal; display: block;">{{ i + 1 }}. {{ err }}</span>
          </div>
      </mat-menu>

      <mat-menu #syncErrors="matMenu" class="offline-status-sub-menu-wrap">
          <div mat-menu-item (click)="$event.stopPropagation(); clearErrorOfflineChangesSyncDocs()">
              <mat-icon>delete_sweep</mat-icon>
              <span>Clear Errors</span>
          </div>
          <mat-divider></mat-divider>
          <div *ngFor="let err of offlineStatus?.errorOfflineChangesSyncDocs; let i = index" mat-menu-item style="height: auto; line-height: normal; padding-top: 8px; padding-bottom: 8px;">
              <span style="white-space: normal; display: block;">{{ i + 1 }}. {{ err }}</span>
          </div>
      </mat-menu>
  </div>
</div>
